import {
  Button, ContactForm, StyledContainer, Trans,
} from '@piwikpro/ui-components';
import { Notifications } from '@piwikpro/notification-crate';
import { withInject } from '@piwikpro/platform';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SidebarLimitBanner.module.css';

interface InjectedProps {
  notifications: Notifications
}

interface SidebarLimitBannerProps extends InjectedProps {
  current: number
  limit: number
}

const SidebarLimitBannerInner = ({
  current,
  limit,
  notifications,
}: SidebarLimitBannerProps) => {
  const { t } = useTranslation();

  return (
    <StyledContainer backgroundImage="gradient1" dataId="SidebarLimitBanner">
      <div className={styles.container}>
        <div className={styles.text}>
          <Trans
            i18nKey="apps.list.limit.text"
            components={{ strong: <strong /> }}
            values={{ limit, current }}
          />
        </div>
        <ContactForm
          type="account"
          onSubmitSuccess={({ message }) => {
            notifications.push({ text: message, type: 'success', autoCloseSeconds: 5 });
          }}
          onSubmitFail={({ message }) => {
            notifications.push({ text: message, type: 'error', autoCloseSeconds: 5 });
          }}
        >
          {({ open }) => (
            <Button onClick={open} text={t('platform.license.contact-us.button')} appearance="simple" />
          )}
        </ContactForm>
      </div>
    </StyledContainer>
  );
};

const SidebarLimitBanner = withInject<InjectedProps>({
  notifications: 'NotificationCrate.notifications',
})(SidebarLimitBannerInner);

export { SidebarLimitBanner };
